import { render, staticRenderFns } from "./PlotDetails.vue?vue&type=template&id=189ed9fc&scoped=true"
import script from "./PlotDetails.vue?vue&type=script&lang=js"
export * from "./PlotDetails.vue?vue&type=script&lang=js"
import style0 from "./PlotDetails.vue?vue&type=style&index=0&id=189ed9fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189ed9fc",
  null
  
)

export default component.exports